export class ImmutableAPIServiceError extends Error {
  constructor(serviceName: string) {
    super(`Service '${serviceName}' is immutable`);
  }
}
